import { render, staticRenderFns } from "./JumpWarn.vue?vue&type=template&id=18671604&scoped=true"
import script from "./JumpWarn.vue?vue&type=script&lang=ts"
export * from "./JumpWarn.vue?vue&type=script&lang=ts"
import style0 from "./JumpWarn.vue?vue&type=style&index=0&id=18671604&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18671604",
  null
  
)

export default component.exports